export const PathConstants = {
  HOME: "/",
  NEW_HOME: "/home",
  LEADS: "/leads",
  LEAD: "leads/:lead_id",
  LEAD_NEW: "leads-new/:lead_id",
  NEXT_ACTIONS: "/next-actions",
  AGENTS_TREE: "/agents-tree",
  SALES: "/sales",
  COMMENTS_SEARCH: "/comments-search",
  SALES_COMMISSIONS: "/sales-commissions",
  NAWY_CALCULATOR: "/nawy-calculator",
  AUTO_DELEGATION_WEIGHTS: "/auto-delegation-weights",
  AGENTS_ACTIVITY: "/agents-activity",
  FACEBOOK_RULES: "/settings/facebook-rules",
  POOLS: "/settings/pools",
  AUTO_ASSIGNMENT_POOLS: "/settings/auto-assignment-pools",
  USERS: "/settings/users",
  AGENTS_TARGETS: "/agents-targets",
  CATEGORIES: "/settings/categories",
  LEAD_ICONS: "/settings/lead-icons",
  LEAD_TAGS: "/settings/lead-tags",
  PAYMENT_PLANS: "/settings/payment-plans",
  STATUSES: "/settings/statuses",
  LOGOUT: "/logout",
  FUNNELS: "/settings/funnels",
  COMMISSIONS: "/commissions",
  DASHBOARDS: "/dashboards",
  LEAGUE: "/league",
  DAILY_OPERATIONS: "/daily-operations",
  NAWY_INVENTORY: "/nawy-inventory",
  STATUSES_GLOSSARY: "/statuses-glossary",
  MARKET_UPDATES: "/market-updates",
  LISTING_DASHBOARD: "/listing-dashboard",
  LISTING_DASHBOARD_EMBED: "/nawy-shares-listing-embed",
  CONFIGURATIONS: "/settings/configurations",
  LOGIN: "/login",
  FRANCHISE_LOGIN: "/franchise-login",
  CHANGE_PASSWORD_FRANCHISE: "/change-password-franchise",
  SEND_EMAIL_FRANCHISE: "/send-email-franchise",
  RESET_PASSWORD: "/reset-password",
  AUTH_CALLBACK: "/authorize",
  AUTH_CHALLENGE: "/auth-challenge",
  TARGET_CONFIGURATIONS: "/settings/target-configurations",
  SELECTED_TARGET_CONFIGURATIONS: "/settings/target-configurations/:uid",
  DISPLAY_ORGANIZATIONS_TARGETS: "/settings/display-organizations-targets",
  SALES_COMMISSIONS_REDIRECTION: "/sales-agents-commissions",
  AMBASSADORS: "/ambassadors",
  TARGET_2: "/targetsv2",
  NOTIFICATIONS_CENTER: "/notifications-center",
  PROPERTY_TRACK_SETTINGS: "/settings/property-tracks",
  PROPERTY_TRACK_SETTINGS_EDIT: "/settings/property-tracks/:trackTypeId",
  CLIENTS: "/clients",
  PROPERTY_TRACKS: "/property-tracks",
  CLIENT: "/clients/:client_id",
  PROPERTY_TRACK: "/property-tracks/:trackId",
  INTERESTS_CONFIGURATION: "/settings/interests",
  INTEREST_ACTIONS_CONFIGURATION: "/settings/interests/:id",
  TASK_DASHBOARD: "/tasks-dashboard",
  REVIEWS: "/reviews",
  LEAD_ACCESS_LINK: "leads-new/:lead_id/status/:status_id/access-link",
  EXPO_DASHBOARD: "/expo-dashboard",
  RENTAL_INVENTORY: "/rental-inventory",
  SETTINGS: "/settings",
  ZOOM_CALLS: "/zoom-calls",
  AI_CONFIGURATIONS: "/settings/ai-configurations",
  PARTNERS: "/partners",
};
